import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    dataCrud(state) {
      return state.dataCrud;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertDataCrud(state, dataCrud) {
      state.dataCrud = dataCrud;
    },
    saveData(state, data) {
      state.status = 'success';
      state.data = data;
    },
    SET_DATA_CRUD(state, payload) {
      state.dataCrud = payload;
    },
    saveError(state) {
      state.status = 'error';
    },
    removeData(state) {
      state.status = 'removed';
    },
    removeError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proProfileBSchema();
        const schema = res.data;

        const resCat1 = await apiClient.catStudiesArea();
        const catStudiesArea = resCat1.data.data;

        const resCat2 = await apiClient.catCareers();
        const catCareers = resCat2.data.data;

        const resCat3 = await apiClient.catEduInstitutions();
        const catEduInstitutions = resCat3.data.data;

        const resCat4 = await apiClient.catInstructionLevels();
        const catInstructionLevels = resCat4.data.data;

        const resCat5 = await apiClient.catInstructionYears();
        const catInstructionYears = resCat5.data.data;

        schema.formCrud.profes_studies_studies_area_code.items = catStudiesArea;
        schema.formCrud.profes_studies_career_code.items = catCareers;
        schema.formCrud.profes_studies_edu_institution_code.items = catEduInstitutions;
        schema.formCrud.profes_studies_instruction_level_code.items = catInstructionLevels;
        schema.formCrud.profes_studies_instruction_year_code.items = catInstructionYears;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadDataCrud({ commit }) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.modelProProfileB(id);
        const dataCrud = res.data.data;
        commit('insertDataCrud', dataCrud);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async save({ commit }, model) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.createProProfileB(id, model);
        let data = {};
        data.statusText = res.statusText;
        commit('saveData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
    async remove({ commit }, id) {
      try {
        let data = {};
        if (id > 0) {
          const res = await apiClient.deleteProProfileB(id);
          const status = res.status;

          if (status === 204) {
            data = res.data;
          }
        }
        commit('removeData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error removiendo');
        commit('removeError');
        throw error;
      }
    },
  },
};
